// extracted by mini-css-extract-plugin
export default {"showroom":"Showroom_showroom__SIDUB","projects__wrapper":"Showroom_projects__wrapper__O-4LK"};